import cn from 'clsx';
import { FC, ReactNode, SyntheticEvent } from 'react';

import { ColorPropsType } from '../../../types';
import BoxButton from '../../Button/Box/BoxButton';
import Icon from '../../Icon';

import s from './RightActionBanner.module.scss';

export interface RightActionBannerProps {
  className?: string;
  title?: string;
  subText?: ReactNode;
  description?: string;
  onClick?: () => void;
  border?: boolean;
  color?: ColorPropsType | 'white';
  buttonLabel?: string;
  illustIcon?: ReactNode;
  listIcon?: boolean;
}

const RightActionBanner: FC<React.PropsWithChildren<React.PropsWithChildren<RightActionBannerProps>>> = ({
  className,
  title = '',
  subText = '',
  description = '',
  buttonLabel = '',
  color = 'gray',
  listIcon = false,
  border = false,
  onClick,
  illustIcon
}) => {
  const handleClickButton = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      onClick={onClick}
      className={cn(
        s.wrap,
        s[color],
        {
          [s.border_gray as string]: border
        },
        className
      )}
    >
      <div className={s.left}>
        {title && <p className={s.title}>{title}</p>}
        {subText && (
          <p
            className={cn(s.subText, {
              // gray테마일때만 subTextColor는 gray.700
              [s.gray_sub_text_color as string]: color === 'gray'
            })}
          >
            {subText}
          </p>
        )}
        {description && <p className={s.description}>{description}</p>}
      </div>

      <div className={s.right}>
        {buttonLabel && (
          <BoxButton color={color === 'white' ? 'violet' : color} onClick={handleClickButton}>
            {buttonLabel}
          </BoxButton>
        )}
        {illustIcon && <div className={s.illustIcon}>{illustIcon}</div>}
        {listIcon && <Icon type="listin-right" width={18} height={24} color="gray.300" />}
      </div>
    </div>
  );
};

export default RightActionBanner;
